import { Container, Header, SpaceBetween, Link } from "@amzn/awsui-components-console";
import { EmbedModuleView } from "@amzn/awt-module-views-react-18";
import { LoadingAnimation, WorkflowModuleProps } from "@amzn/region-flex-interface-module-website-common";
import { useMigrationSteps } from "../hooks/useMigrationSteps";

export const MigrationStepLoader = (props: WorkflowModuleProps) => {
  const migrationSteps = useMigrationSteps();

  const module = migrationSteps?.find((step) => step.contributorModuleId === `@amzn/rfp-${props.moduleId}`);

  return (
    <SpaceBetween size="l">
      <Container header={<Header>User Information</Header>}>
        {module ? (
          <>
            <EmbedModuleView
              viewTypeDefinition={module.data.view}
              providerModuleId={module.contributorModuleId}
              renderFailed={(error) => {
                console.log(error);
                return (
                  <div>
                    <p>
                      Error loading module {module.contributorModuleId}: {error.error.errorMessage}
                    </p>
                    <p>
                      Please try refreshing this page. Should the problem persist, don&apos;t hesitate to contact our
                      team at{" "}
                      <Link href="https://amazon.enterprise.slack.com/archives/C0748F66GET" target="_blank">
                        #rfp-helpdesk
                      </Link>{" "}
                      for assistance.
                    </p>
                  </div>
                );
              }}
              viewProps={props}
              renderWaiting={() => <LoadingAnimation />}
              onError={(error) => console.error(error)}
            />
          </>
        ) : (
          <p>No Mesh module found for step {props.moduleId}</p>
        )}
      </Container>
    </SpaceBetween>
  );
};
